// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const INSTAGRAM_POST_DELETED = "(zmazan\u00e9)";
